import { classNames } from '../utilities';

export const IntakeIcon = ({ className, onClick, isFill }) => {
  return (
    <svg
      className={classNames(
        'alert-icon cursor-pointer',
        className ? className : ''
      )}
      onClick={onClick ? onClick : () => null}
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="12" height="14" rx="8" />
      <path
        d="M7.2 0H4.8C4.32261 0 3.86477 0.221249 3.52721 0.615076C3.18964 1.0089 3 1.54305 3 2.1V2.8H1.8C1.32261 2.8 0.864773 3.02125 0.527208 3.41508C0.189642 3.8089 0 4.34305 0 4.9V11.9C0 12.457 0.189642 12.9911 0.527208 13.3849C0.864773 13.7788 1.32261 14 1.8 14H10.2C10.6774 14 11.1352 13.7788 11.4728 13.3849C11.8104 12.9911 12 12.457 12 11.9V4.9C12 4.34305 11.8104 3.8089 11.4728 3.41508C11.1352 3.02125 10.6774 2.8 10.2 2.8H9V2.1C9 1.54305 8.81036 1.0089 8.47279 0.615076C8.13523 0.221249 7.67739 0 7.2 0ZM4.2 2.1C4.2 1.91435 4.26321 1.7363 4.37574 1.60503C4.48826 1.47375 4.64087 1.4 4.8 1.4H7.2C7.35913 1.4 7.51174 1.47375 7.62426 1.60503C7.73679 1.7363 7.8 1.91435 7.8 2.1V2.8H4.2V2.1ZM10.8 4.9V11.9C10.8 12.0857 10.7368 12.2637 10.6243 12.395C10.5117 12.5263 10.3591 12.6 10.2 12.6H1.8C1.64087 12.6 1.48826 12.5263 1.37574 12.395C1.26321 12.2637 1.2 12.0857 1.2 11.9V4.9C1.2 4.71435 1.26321 4.5363 1.37574 4.40503C1.48826 4.27375 1.64087 4.2 1.8 4.2H10.2C10.3591 4.2 10.5117 4.27375 10.6243 4.40503C10.7368 4.5363 10.8 4.71435 10.8 4.9ZM6.6 7.7H7.8V9.1H6.6V10.5H5.4V9.1H4.2V7.7H5.4V6.3H6.6V7.7Z"
        fill={isFill ? 'black' : 'white'}
      />
    </svg>
  );
};
